import Component from '../../../assets/scripts/modules/component';
import fireCustomEvent from '../../../vendor/scripts/fabrique/modules/fire-custom-event';


class Copyright extends Component {
  init() {

    window.addEventListener('copyright:start', () => {

        // open lightbox
        fireCustomEvent('lightbox:show', { id: 'copyright' });

        // show content
        this.show();
    });
  }

  show() {
    this.element.classList.add('is-visible');
  }

  hide() {
    this.element.classList.remove('is-visible');
  }
}

for (const element of document.querySelectorAll('.copyright')) {
  element.instance = new Copyright('copyright', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/structures/copyright/copyright.js